import React, {useCallback, useState} from 'react'
import {MorePage} from './MorePage.tsx'

export interface MorePageContainerProps {
    onNavigate: (path: string) => void
    onExternalNavigate: (url: string) => void
    onLanguageClick: () => void
    onRulebookClick: () => void
    initialShowCareersNotification: boolean
    dismissCareersNotification: () => void
    faqExternalUrl?: string
}

export const MorePageContainer = ({
    onNavigate,
    onExternalNavigate,
    onLanguageClick,
    onRulebookClick,
    initialShowCareersNotification,
    dismissCareersNotification,
    faqExternalUrl,
}: MorePageContainerProps) => {
    const [showCareersNotification, setShowCareersNotification] = useState(initialShowCareersNotification)

    const onPatchNotesClick = useCallback(() => onNavigate('/patch-notes'), [onNavigate])
    const onFaqClick = useCallback(() => {
        if(faqExternalUrl) onExternalNavigate(faqExternalUrl)
        else onNavigate('/faq')
    }, [faqExternalUrl, onExternalNavigate, onNavigate])
    const onChampionshipClick = useCallback(() => onNavigate('/championship2026'), [onNavigate])
    const onPlayerHubClick = useCallback(() => onNavigate('/community'), [onNavigate])
    const onBlogClick = useCallback(() => onExternalNavigate('https://blog.colonist.io/'), [onExternalNavigate])
    const onAboutClick = useCallback(() => onNavigate('/about'), [onNavigate])
    const onCareersClick = useCallback(() => {
        setShowCareersNotification(false)
        dismissCareersNotification()
        onNavigate('/careers')
    }, [onNavigate, dismissCareersNotification])
    const onPrivacyClick = useCallback(() => onNavigate('/privacy-policy'), [onNavigate])

    return (
        <MorePage
            showCareersNotification={showCareersNotification}
            onPatchNotesClick={onPatchNotesClick}
            onLanguageClick={onLanguageClick}
            onRulebookClick={onRulebookClick}
            isFaqExternal={!!faqExternalUrl}
            onFaqClick={onFaqClick}
            onChampionshipClick={onChampionshipClick}
            onPlayerHubClick={onPlayerHubClick}
            onBlogClick={onBlogClick}
            onAboutClick={onAboutClick}
            onCareersClick={onCareersClick}
            onPrivacyClick={onPrivacyClick}
        />
    )
}
